module.exports = __webpack_public_path__ + "img/map.ea71c996.png";